import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { ESTADOS_PERIODO_CIERRE_MENSUAL } from "../../../../../helpers/tiposCierreMensual";
const refreshIcon = require("assets/img/icons/refresh.png");

// El rango filtra por el fin del período, que es lo que identifica al documento:
// la fecha de corte solo la tiene el cierre de bodega. El estado filtra por las
// mitades que el período ya tiene registradas
export const FiltrosCierresMensuales = ({ control, onRefresh, resetPage }) => {
    return (
        <div className="formulario-fields-row align-items-end my-0">
            <div className="formulario-field">
                <label htmlFor="estado" className="m-0">
                    Estado del período
                </label>
                <Controller
                    name="estado"
                    control={control}
                    render={({ field }) => (
                        <Select
                            inputId="estado"
                            className="react-select-container"
                            isClearable
                            options={ESTADOS_PERIODO_CIERRE_MENSUAL}
                            value={field.value}
                            onChange={(opcion) => {
                                field.onChange(opcion);
                                resetPage();
                            }}
                            placeholder="Todos"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 20,
                                }),
                            }}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_inicial" className="m-0">
                    Período desde
                </label>
                <Controller
                    name="fecha_inicial"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha de inicio"
                            maxDate={control._formValues.fecha_final}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_final" className="m-0">
                    Período hasta
                </label>
                <Controller
                    name="fecha_final"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha final"
                            minDate={control._formValues.fecha_inicial}
                        />
                    )}
                />
            </div>
            <img
                src={refreshIcon}
                alt="Refrescar listado"
                title="Refrescar listado"
                className="action_img mb-1"
                onClick={() => {
                    onRefresh();
                }}
            />
        </div>
    );
};
